export const mySource = {
  mySourceStatusOpen: 'MySource3.0-status-open',
  mySourceStatusClose: 'MySource3.0-status-close',
  mySourceSearch: 'MySource3.0-searchSource',
  mySourceBookmarkOpen: 'MySource3.0-bookmark-open',
  // status
  mySourceStatusAllSelected: 'MySource3.0-statusAll-selected',
  mySourceStatusAllUnselect: 'MySource3.0-statusAll-unselect',
  mySourceStatusonlineSelected: 'MySource3.0-statusOnline-selected',
  mySourceStatusonlineUnselect: 'MySource3.0-statusOnline-unselect',
  mySourceStatusnoCameraSelected: 'MySource3.0-statusNoCamera-selected',
  mySourceStatusnoCameraUnselect: 'MySource3.0-statusNoCamera-unselect',
  mySourceStatuslivingSelected: 'MySource3.0-statusLiving-selected',
  mySourceStatuslivingUnselect: 'MySource3.0-statusLiving-unselect',
  mySourceStatusofflineSelected: 'MySource3.0-statusOffline-selected',
  mySourceStatusofflineUnselect: 'MySource3.0-statusOffline-unselect',
  // type
  mySourceTypeAllSelected: 'MySource3.0-typeAll-selected',
  mySourceTypeAllUnselect: 'MySource3.0-typeAll-unselect',
  mySourceTypepackSelected: 'MySource3.0-typePack-selected',
  mySourceTypepackUnselect: 'MySource3.0-typePack-unselect',
  mySourceTypeanywhereSelected: 'MySource3.0-typeAnywhere-selected',
  mySourceTypeanywhereUnselect: 'MySource3.0-typeAnywhere-unselect',
  mySourceTypegridPackSelected: 'MySource3.0-typeGridPack-selected',
  mySourceTypegridPackUnselect: 'MySource3.0-typeGridPack-unselect',
  mySourceTypegridSdiSelected: 'MySource3.0-typeGridSdi-selected',
  mySourceTypegridSdiUnselect: 'MySource3.0-typeGridSdi-unselect',
  mySourceTypeextSelected: 'MySource3.0-typeExt-selected',
  mySourceTypeextUnselect: 'MySource3.0-typeExt-unselect',
  mySourceTypegridViaTokenSelected: 'MySource3.0-typeGridViaToken-selected',
  mySourceTypegridViaTokenUnselect: 'MySource3.0-typeGridViaToken-unselect',
  mySourceTypeglobalGridSelected: 'MySource3.0-typeGlobalGrid-selected',
  mySourceTypeglobalGridUnselect: 'MySource3.0-typeGlobalGrid-unselect',
  // sort
  mySourceSortonlineFirst: 'MySource3.0-sortOnlineFirst',
  mySourceSortliveFirst: 'MySource3.0-sortLiveFirst',
  mySourceSortnameFirst: 'MySource3.0-sortNameFirst',
  // add btn
  mySourceAddExtOpen: 'MySource3.0-addExt-open',
  mySourceAddExtClose: 'MySource3.0-addExt-close',
  mySourceSaveExt: 'MySource3.0-saveExt',
  // selected ext type
  mySourceAddExtTypeExt: 'MySource3.0-addExtTypeExt',
  mySourceAddExtTypeSMPTE2022: 'MySource3.0-addExtTypeSMPTE2022',
  mySourceAddExtTypeYouTube: 'MySource3.0-addExtTypeYouTube',
  mySourceAddExtTypeGridToken: 'MySource3.0-addExtTypeGridToken',
  //
  mySourceSourceContent: 'MySource3.0-jumpSourceContent',
  mySourceSourceList: 'MySource3.0-jumpSourceList',
  mySourceSourceMap: 'MySource3.0-jumpSourceMap',
  // live or stop
  mySourceBtnLive: 'MySource3.0-takeBtn-live',
  mySourceBtnStop: 'MySource3.0-stopBtn-stop',
  // config-T
  mySourceConfitT: 'MySource3.0-configT',
  // setting box
  mySourceSelect: 'MySource3.0-select-model',
  mySourceSpeed: 'MySource3.0-selectQuality-6',
  mySourceDynamic: 'MySource3.0-setDelay-dynamic',
  mySourceFixed: 'MySource3.0-setDelay-fixed',
  mySourcevbr: 'MySource3.0-setBitrate-vbr',
  mySourcecbr: 'MySource3.0-setBitrate-cbr',
  // set model
  mySourceModelInterview: 'MySource3.0-model-interview',
  mySourceModelNormal: 'MySource3.0-model-normal',
  mySourceModelFastMoving: 'MySource3.0-model-fastMoving',
  mySourceModelSD: 'MySource3.0-model-sd',
  mySourceModelTapeFeed: 'MySource3.0-model-tapeFeed',
  mySourceModelUser1: 'MySource3.0-model-user1',
  mySourceModelUser2: 'MySource3.0-model-user2retretret',
  // media
  mySourceOpenShare: 'MySource3.0-share-open',
  mySourceCloseShare: 'MySource3.0-share-close',
  // speed
  'mySourceSpeed1.2Mb/s': 'MySource3.0-searchSource-1.2Mb/s',
  'mySourceSpeed2.4Mb/s': 'MySource3.0-searchSource-2.4Mb/s',
  'mySourceSpeed6Mb/s': 'MySource3.0-searchSource-6Mb/s',
  'mySourceSpeed12Mb/s': 'MySource3.0-searchSource-12Mb/s',
  'mySourceSpeed24Mb/s': 'MySource3.0-searchSource-24Mb/s',
  'mySourceSpeed30Mb/s': 'MySource3.0-searchSource-30Mb/s',
  'mySourceSpeed50Mb/s': 'MySource3.0-searchSource-50Mb/s',
  'mySourceSpeed100Mb/s': 'MySource3.0-searchSource-100Mb/s',
  'mySourceSpeed120Mb/s': 'MySource3.0-searchSource-120Mb/s',
  'mySourceSpeed150Mb/s': 'MySource3.0-searchSource-150Mb/s',
  'mySourceSpeed180Mb/s': 'MySource3.0-searchSource-180Mb/s',
  // voip
  mySourceVoipStart: 'MySource3.0-voip-start',
  mySourceVoipStop: 'MySource3.0-voip-stop',
  // video
  mySourceVideoClose: 'MySource3.0-video-close',
  mySourceVideoOpen: 'MySource3.0-video-open',
  // anywhere camera相关
  mySourceOpenCamera: 'MySource3.0-AnywhereCamera-open',
  mySourceCloseCamera: 'MySource3.0-AnywhereCamera-close',
  mySourceCameraManual: 'MySource3.0-AnywhereCamera-manual',
  mySourceCameraAuto: 'MySource3.0-AnywhereCamera-auto',
  mySourceCameraReset: 'MySource3.0-AnywhereCamera-reset',
  mySourceGotoMap: 'MySource3.0-LocationMap-open',
  mySourceChangeLarge: 'MySource3.0-ChangeLargeSize',
  mySourceChangeMedium: 'MySource3.0-ChangeMediumSize',
  mySourceChangeSmall: 'MySource3.0-ChangeSmallSize',

  mySourceTableBitrate: 'MySource3.0-Table-bitrate',
  mySourceTableLatency: 'MySource3.0-Table-latency',
  mySourceTableFormat: 'MySource3.0-Table-format',
  mySourceTableBattery: 'MySource3.0-Table-battery',
  mySourceTableBookmark: 'MySource3.0-Table-bookmark',
  mySourceTableTypeVal: 'MySource3.0-Table-type',
  mySourceTableVersion: 'MySource3.0-Table-version',
  mySourceTableLocation: 'MySource3.0-Table-location',
  // 表格比特率延迟显示
  mySourceTableBiterShow: 'MySource3.0-Table-BiterShow',
  mySourceTableSetBiterVbr: 'MySource3.0-Table-SetBiterVbr',
  mySourceTableSetBiterCbr: 'MySource3.0-Table-SetBiterCbr',
  mySourceTableSetBiterVal: 'MySource3.0-Table-SetBiterVal',
  mySourceTableDelayShow: 'MySource3.0-Table-DelayShow',
  mySourceTableSetDelayDynamic: 'MySource3.0-Table-SetDelayDynamic',
  mySourceTableSetDelayFixed: 'MySource3.0-Table-SetDelayFixed',
  mySourceTableSetDelayVal: 'MySource3.0-Table-SetDelayVal',
  mySourceTableShowBookmark: 'MySource3.0-Table-ShowBookmark',
  mySourceTableCloseBookmark: 'MySource3.0-Table-CloseBookmark',
  mySourceTableShowVideo: 'MySource3.0-Table-ShowVideo',
  mySourceTableSelectR: 'MySource3.0-Table-SelectR',
  mySourceTableDragColumn: 'MySource3.0-Table-DragColumn',
  mySourceTableColumnStretch: 'MySource3.0-Table-ColumnStretch',
  mySourceTableBookmarkSave: 'MySource3.0-Table-BookmarkSave'
}

export const advancedControl = {
  // peerlist
  adSourceList: 'AdvancedControl3.0-RList-show',
  adSearch: 'AdvancedControl3.0-searchSource',
  // status
  adStatuslivingOpen: 'AdvancedControl3.0-statusLive-open',
  adStatuslivingClose: 'AdvancedControl3.0-statusLive-close',
  adStatusonlineOpen: 'AdvancedControl3.0-statusOnline-open',
  adStatusonlineClose: 'AdvancedControl3.0-statusOnline-close',
  adStatusofflineOpen: 'AdvancedControl3.0-statusOffline-open',
  adStatusofflineClose: 'AdvancedControl3.0-statusOffline-close',
  // type
  adTypeallOpen: 'AdvancedControl3.0-typeAll-open',
  adTypeallClose: 'AdvancedControl3.0-typeAll-close',
  adTypepackOpen: 'AdvancedControl3.0-typePack-open',
  adTypepackClose: 'AdvancedControl3.0-typePack-close',
  adTypeanywhereOpen: 'AdvancedControl3.0-typeAnywhere-open',
  adTypeanywhereClose: 'AdvancedControl3.0-typeAnywhere-close',
  adTypegridPackOpen: 'AdvancedControl3.0-typeGridPack-open',
  adTypegridPackClose: 'AdvancedControl3.0-typeGridPack-close',
  adTypegridSdiOpen: 'AdvancedControl3.0-typeGridSDI-open',
  adTypegridSdiClose: 'AdvancedControl3.0-typeGridSDI-close',
  adTypeextOpen: 'AdvancedControl3.0-typeExt-open',
  adTypeextClose: 'AdvancedControl3.0-typeExt-close',
  // sort
  adSortonlineFirst: 'AdvancedControl3.0-onlineFirst',
  adSortliveFirst: 'AdvancedControl3.0-liveFirst',
  adSortnameFirst: 'AdvancedControl3.0-nameFirst',

  // list
  adListThumbnailList: 'AdvancedControl3.0-thumbnailList',
  adListSourceList: 'AdvancedControl3.0-sourceList',
  adListSelectSource: 'AdvancedControl3.0-sourceThumbnail-select',

  // addVideo Dialog
  adDialogVideoOpen: 'AdvancedControl3.0-videoType-open',
  adDialogVideoClose: 'AdvancedControl3.0-videoType-close',
  adDialogExtOpen: 'AdvancedControl3.0-addExt-open',
  adDialogExtClose: 'AdvancedControl3.0-addExt-close',
  adDialogExtSave: 'AdvancedControl3.0-addExt-save',
  adDialogSMPTE2022Open: 'AdvancedControl3.0-addSMPTE2022-open',
  adDialogSMPTE2022Close: 'AdvancedControl3.0-addSMPTE2022-close',
  adDialogSMPTE2022Save: 'AdvancedControl3.0-addSMPTE2022-save',
  adDialogYouTubeOpen: 'AdvancedControl3.0-addYoutube-open',
  adDialogYouTubeClose: 'AdvancedControl3.0-addYoutube-close',
  adDialogYouTubeSave: 'AdvancedControl3.0-addYoutube-save',
  adDialogYouTubeValidate: 'AdvancedControl3.0-Youtube-validate',

  // Downloaded Files Dialog
  adDialogDownloadOpen: 'AdvancedControl3.0-downloadedFiles-open',
  adDialogDownloadClose: 'AdvancedControl3.0-downloadedFiles-close',
  adDialogDownloadDelete: 'AdvancedControl3.0-downloadedFiles-delete',
  adDialogDownloadDeleteAll: 'AdvancedControl3.0-downloadedFiles-deleteAll',

  // video区域
  adVideoSelectSource: 'AdvancedControl3.0-videoSource-select',
  adVideoTake: 'AdvancedControl3.0-video-take',
  adVideoStop: 'AdvancedControl3.0-video-stop',

  adVideoInterview: 'AdvancedControl3.0-video-Interview',
  adVideoNormal: 'AdvancedControl3.0-video-Normal',
  adVideoFastMoving: 'AdvancedControl3.0-video-FastMoving',
  adVideoSD: 'AdvancedControl3.0-video-SD',
  adVideoTapeFeed: 'AdvancedControl3.0-video-TapeFeed',
  adVideoUser1: 'AdvancedControl3.0-video-User1',
  adVideoUser2retretret: 'AdvancedControl3.0-video-User2retretret',
  // bit
  'adVideo1.2Mb/s': 'AdvancedControl3.0-video-1.2Mb/s',
  'adVideo2.4Mb/s': 'AdvancedControl3.0-video-2.4Mb/s',
  'adVideo6Mb/s': 'AdvancedControl3.0-video-6Mb/s',
  'adVideo12Mb/s': 'AdvancedControl3.0-video-12Mb/s',
  'adVideo24Mb/s': 'AdvancedControl3.0-video-24Mb/s',
  'adVideo30Mb/s': 'AdvancedControl3.0-video-30Mb/s',
  'adVideo50Mb/s': 'AdvancedControl3.0-video-50Mb/s',
  'adVideo100Mb/s': 'AdvancedControl3.0-video-100Mb/s',
  'adVideo120Mb/s': 'AdvancedControl3.0-video-120Mb/s',
  'adVideo150Mb/s': 'AdvancedControl3.0-video-150Mb/s',
  'adVideo180Mb/s': 'AdvancedControl3.0-video-180Mb/s',
  // live
  adLiveTab: 'AdvancedControl3.0-liveTab',
  adLiveFlowOpen: 'AdvancedControl3.0-liveFlow-open',
  adLiveFlowClose: 'AdvancedControl3.0-liveFlow-close',
  adLiveConfigT: 'AdvancedControl3.0-liveConfigT',
  adLiveReset: 'AdvancedControl3.0-liveReset',
  'adLive1.2Mb/s': 'AdvancedControl3.0-live-1.2Mb/s',
  'adLive2.4Mb/s': 'AdvancedControl3.0-live-2.4Mb/s',
  'adLive6Mb/s': 'AdvancedControl3.0-live-6Mb/s',
  'adLive12Mb/s': 'AdvancedControl3.0-live-12Mb/s',
  'adLive24Mb/s': 'AdvancedControl3.0-live-24Mb/s',
  'adLive30Mb/s': 'AdvancedControl3.0-live-30Mb/s',
  'adLive50Mb/s': 'AdvancedControl3.0-live-50Mb/s',
  'adLive100Mb/s': 'AdvancedControl3.0-live-100Mb/s',
  'adLive120Mb/s': 'AdvancedControl3.0-live-120Mb/s',
  'adLive150Mb/s': 'AdvancedControl3.0-live-150Mb/s',
  'adLive180Mb/s': 'AdvancedControl3.0-live-180Mb/s',

  // record
  adRecordTab: 'AdvancedControl3.0-recordTab',
  adRecordLastWeek: 'AdvancedControl3.0-recordLastWeek',
  adRecordNextWeek: 'AdvancedControl3.0-recordNextWeek',
  adRecordDay: 'AdvancedControl3.0-recordDay',
  adRecordDownloadAll: 'AdvancedControl3.0-record-downloadAll',
  adRecordPreview: 'AdvancedControl3.0-record-preview',
  adRecordDownload: 'AdvancedControl3.0-record-download',
  adRecordFileDownload: 'AdvancedControl3.0-recordFile-download',
  adRecordDownloadPlay: 'AdvancedControl3.0-recordDownload-play',
  adRecordFTPPlay: 'AdvancedControl3.0-recordFTP-play',
  adRecordDownloadDelete: 'AdvancedControl3.0-recordDownload-delete',
  adRecordFTPDelete: 'AdvancedControl3.0-recordFTP-delete',
  adRecordFileDownloadAll: 'AdvancedControl3.0-recordFile-downloadAll',
  adRecordFTPDownloadAll: 'AdvancedControl3.0-recordFTP-downloadAll',
  adRecordDownloadModule: 'AdvancedControl3.0-recordDownloadModule',
  adRecordFTPModule: 'AdvancedControl3.0-recordFTPModule',

  // setting
  adSettingOpen: 'AdvancedControl3.0-setting-open',
  adSettingClose: 'AdvancedControl3.0-setting-close',
  adSettingbase: 'AdvancedControl3.0-setting-basic',
  adSettinglocalAllPack: 'AdvancedControl3.0-setting-localAllPack',
  adSettingfeatureOpen: 'AdvancedControl3.0-settingFeature-open',
  adSettingfeatureClose: 'AdvancedControl3.0-settingFeature-close',
  adSettinggridEncoderOpen: 'AdvancedControl3.0-settingGridEncoder-open',
  adSettinggridEncoderClose: 'AdvancedControl3.0-settingGridEncoder-close',
  adSettingsmartCaptionOpen: 'AdvancedControl3.0-settingSmartCaption-open',
  adSettingsmartCaptionClose: 'AdvancedControl3.0-settingSmartCaption-close',
  adSettingsmartCaptionSave: 'AdvancedControl3.0-settingSmartCaption-save',
  adSettingsdiOpen: 'AdvancedControl3.0-settingSDI-open',
  adSettingsdiClose: 'AdvancedControl3.0-settingSDI-close',
  adSettingvisionTagOpen: 'AdvancedControl3.0-settingVisionTag-open',
  adSettingvisionTagClose: 'AdvancedControl3.0-settingVisionTag-close',
  adSettingvisionTagSave: 'AdvancedControl3.0-settingVisionTag-save',
  adSettingautoRecordOpen: 'AdvancedControl3.0-settingAutoRecord-open',
  adSettingautoRecordClose: 'AdvancedControl3.0-settingAutoRecord-close',

  adSettingVLANSettingOpen: 'AdvancedControl3.0-settingVLANSetting-open',
  adSettingVLANSettingClose: 'AdvancedControl3.0-settingVLANSetting-close',
  adSettingTokenServiceOpen: 'AdvancedControl3.0-settingTokenService-open',
  adSettingTokenServiceClose: 'AdvancedControl3.0-settingTokenService-close',
  adSettingipStreamOutOpen: 'AdvancedControl3.0-settingipStreamOut-open',
  adSettingipStreamOutClose: 'AdvancedControl3.0-settingipStreamOut-close',
  adSettingTokenServiceCreate: 'AdvancedControl3.0-settingTokenService-Create',
  adSettingTokenServiceSetCkeckToken:
    'AdvancedControl3.0-settingTokenServiceSet-CkeckToken',
  adSettingTokenServiceSetSetToken:
    'AdvancedControl3.0-settingTokenServiceSet-SetToken',
  adSettingipStreamOutPrefileAdd:
    'AdvancedControl3.0-settingipStreamOutPrefile-Add',
  adSettingVLANSettingRefresh: 'AdvancedControl3.0-settingVLANSetting-Refresh',
  adSettingVLANSettingStopInterface:
    'AdvancedControl3.0-settingVLANSetting-StopInterface',
  adSettingVLANSettingApply: 'AdvancedControl3.0-settingVLANSetting-Apply',
  adSettingVLANSettingRightRefresh:
    'AdvancedControl3.0-settingVLANSetting-RightRefresh',

  adSettinautoDownloadOpen: 'AdvancedControl3.0-settingAutoDownload-open',
  adSettinautoDownloadClose: 'AdvancedControl3.0-settingAutoDownload-close',
  adSettingprogressDownloadOpen: 'AdvancedControl3.0-settingProgressDownload-open',
  adSettingprogressDownloadClose:
    'AdvancedControl3.0-settingProgressDownload-close',
  adSettinglocationOpen: 'AdvancedControl3.0-settingLocation-open',
  adSettinglocationClose: 'AdvancedControl3.0-settingLocation-close',
  adSettingipAndPortOpen: 'AdvancedControl3.0-settingIpAndPort-open',
  adSettingipAndPortClose: 'AdvancedControl3.0-settingIpAndPort-close',
  adSettingipAndPortSave: 'AdvancedControl3.0-settingIpAndPort-save',
  adSettingmediaOpen: 'AdvancedControl3.0-settingMedia-open',
  adSettingmediaClose: 'AdvancedControl3.0-settingMedia-close',
  adSettingmediaSave: 'AdvancedControl3.0-settingMedia-save',

  // Rlist
  adRList: 'AdvancedControl3.0-RTab-select',
  adSelectR: 'AdvancedControl3.0-R-select',
  adRSearch: 'AdvancedControl3.0-R-search',
  // status
  adRStatuslivingOpen: 'AdvancedControl3.0-RstatusLive-open',
  adRStatuslivingClose: 'AdvancedControl3.0-RstatusLive-close',
  adRStatusonlineOpen: 'AdvancedControl3.0-RstatusOnline-open',
  adRStatusonlineClose: 'AdvancedControl3.0-RstatusOnline-close',
  adRStatusofflineOpen: 'AdvancedControl3.0-RstatusOffline-open',
  adRStatusofflineClose: 'AdvancedControl3.0-RstatusOffline-close',
  // sort
  adRSortonlineFirst: 'AdvancedControl3.0-R-onlineFirst',
  adRSortliveFirst: 'AdvancedControl3.0-R-liveFirst',
  adRSortnameFirst: 'AdvancedControl3.0-R-nameFirst',
  // stop
  adRStop: 'AdvancedControl3.0-R-stop',
  // multi-control
  showMultiControlRC: 'AdvancedControl3.0-showMultiControl',
  setTimeLockRC: 'AdvancedControl3.0-setTimelock',
  stopTimeLockRC: 'AdvancedControl3.0-stopTimelock',
  setTimeLockBitrateBySliderRC:
    'AdvancedControl3.0-multiContorl-setBitrate-bySilder',
  setTimeLockDelayBySilderRC: 'AdvancedControl3.0-multiContorl-setDelay-bySilder',
  setTimeLockBitrateByInputRC: 'AdvancedControl3.0-multiContorl-setBitrate-byInput',
  setTimeLockDelayByInputRC: 'AdvancedControl3.0-multiContorl-setDelay-byInput',
  selectTimeLockReceiverByDropRC:
    'AdvancedControl3.0-multiContorl-selectReceiver-byDrop',
  cancelSelectTimeLockReceiverByDropRC:
    'AdvancedControl3.0-multiContorl-cancelSelectReceiver-byDrop',
  cancelSelectTimLockReceiverByClickBtnRC:
    'AdvancedControl3.0-multiContorl-cancelSelectReceiver-byClickBtn',
  showWebPageRC: 'AdvancedControl3.0-multiContorl-showWebR',
  showReceiverInfoRC: 'AdvancedControl3.0-multiContorl-showReceiverInfo',
  clickMuteButtonRC: 'AdvancedControl3.0-multiContorl-clickMuteButton',
  clickVoiceButtonRC: 'AdvancedControl3.0-multiContorl-clickVoiceButton',
  selectSourceRC: 'AdvancedControl3.0-multiContorl-clickVoiceButton',
  clickStartButtonRC: 'AdvancedControl3.0-multiContorl-startLive',
  clickStopButtonRC: 'AdvancedControl3.0-multiContorl-stopLive',
  closeMultiControlRC: 'AdvancedControl3.0-multiContorl-close',
  // ip stream out
  enableEncoderRC: 'AdvancedControl3.0-ipStreamOut-encoderEnable',
  disableEncoderRC: 'AdvancedControl3.0-ipStreamOut-encoderDisable',
  enableCbrRC: 'AdvancedControl3.0-ipStreamOut-cbrEnable',
  disableCbrRC: 'AdvancedControl3.0-ipStreamOut-cbrDisable',
  setResolutionRC: 'AdvancedControl3.0-ipStreamOut-setResolution',
  setBitrateRC: 'AdvancedControl3.0-ipStreamOut-setBitrate',
  setABitrateRC: 'AdvancedControl3.0-ipStreamOut-setABitrate',
  setAChannelRC: 'AdvancedControl3.0-ipStreamOut-setAChannel',
  setCodecRC: 'AdvancedControl3.0-ipStreamOut-setCodec',
  setCopierRC: 'AdvancedControl3.0-ipStreamOut-setFileCopier',
  setCopierHM: 'Home-ipStreamOut-setFileCopier',
  addNewShareAccountRC: 'AdvancedControl3.0-ipStreamOut-addNewShareAccount',
  startPushStreamRC: 'AdvancedControl3.0-ipStreamOut-pushStream',
  stopPushStreamRC: 'AdvancedControl3.0-ipStreamOut-stopPushStream',
  uploadLogoRC: 'AdvancedControl3.0-ipStreamOut-uploadLogo',
  SharedMemoryRC: 'AdvancedControl3.0-ipStreamOut-SharedMemory',

  // media
  adOpenShare: 'AdvancedControl3.0-share-open',
  adCloseShare: 'AdvancedControl3.0-share-close'
}

export const myReceivers = {
  myReceiversMuteVolumeOff: 'MyReceivers3.0-muteVolume-off',
  myReceiversMuteVolumeOn: 'MyReceivers3.0-muteVolume-on',
  myReceiversVideoSetClose: 'MyReceivers3.0-setVideoSetup-close', // 显示延迟设置 无
  myReceiversVideoSetOpen: 'MyReceivers3.0-setVideoSetup-open', // 显示延迟设置 无
  myReceiversVideoParameterOpen: 'MyReceivers3.0-viewVideoParameter-open',
  myReceiversVideoParameterClose: 'MyReceivers3.0-viewVideoParameter-close',
  myReceiversFavoriteYes: 'MyReceivers3.0-addFavorite-yes',
  myReceiversFavoriteNo: 'MyReceivers3.0-addFavorite-no',
  myReceiversSearchDestination: 'MyReceivers3.0-searchDestination',
  myReceiversSearchSource: 'MyReceivers3.0-searchSource', // 查询T的类型 在ncc内无
  myReceiversPreviewVideoClose: 'MyReceivers3.0-previewVideo-close',
  myReceiversPreviewVideoOpen: 'MyReceivers3.0-previewVideo-open',
  myReceiversPreviewVideoDown: 'MyReceivers3.0-previewVideo-Down', // 点击眼睛 在ncc无 现修改成展开下拉
  myReceiversPreviewVideoUp: 'MyReceivers3.0-previewVideo-Up', // 点击眼睛 在ncc无 现修改成关闭下拉
  myReceiversMemoSave: 'MyReceivers3.0-memo-save',
  myReceiversMemoFocus: 'MyReceivers3.0-memo-focus',
  // media
  myReceiversOpenShare: 'MyReceivers3.0-share-open',
  myReceiversCloseShare: 'MyReceivers3.0-share-close',
  /*
   * 筛选R条件的谷歌统计
   *
   */
  myReceiversFilterAllSelected: 'MyReceivers3.0-filterAll-selected',
  myReceiversFilterAllUnselect: 'MyReceivers3.0-filterAll-unselect',
  myReceiversFilterLiveSelected: 'MyReceivers3.0-filterLive-selected',
  myReceiversFilterLiveUnselect: 'MyReceivers3.0-filterLive-unselect',
  myReceiversFilterOnlineSelected: 'MyReceivers3.0-filterOnline-selected',
  myReceiversFilterOnlineUnselect: 'MyReceivers3.0-filterOnline-unselect',
  myReceiversFilterOfflineSelected: 'MyReceivers3.0-filterOffline-selected',
  myReceiversFilterOfflineUnselect: 'MyReceivers3.0-filterOffline-unselect',
  myReceiversFilterFavoriteSelected: 'MyReceivers3.0-filterFavorite-selected',
  myReceiversFilterFavoriteUnselect: 'MyReceivers3.0-filterFavorite-unselect',
  myReceiversFilterSortSelected: 'MyReceivers3.0-filterSort-selected',
  myReceiversFilterSortUnselect: 'MyReceivers3.0-filterSort-unselect',
  /*
   * 筛选R条件的谷歌统计结束
   *
   */
  myReceiversNavPagePrevious: 'MyReceivers3.0-navPagePrevious',
  myReceiversNavPageNext: 'MyReceivers3.0-navPageNext',
  myReceiverGotoMap: 'MyReceivers3.0-LocationMap-open',
  // 8.25新增功能添加到分析
  myRecevierChangeLarge: 'MyReceivers3.0-ChangeLargeSize',
  myRecevierChangeMedium: 'MyReceivers3.0-ChangeMediumSize',
  myRecevierChangeSmall: 'MyReceivers3.0-ChangeSmallSize',
  myRecevierSearchSource: 'MyReceivers3.0-searchSource',
  myRecevierselectSource: 'MyReceivers3.0-selectSource'
}

export const token = {
  pageName: 'Token3.0',
  tokenCreateToken: function () {
    return `${this.pageName}-createToken`
  },
  tokenEditToken: function () {
    return `${this.pageName}-editToken`
  },
  tokenDeleteToken: function () {
    return `${this.pageName}-deleteToken`
  },
  /*
   * tokenGridSendEmail: function () {
   *     return `${this.pageName}-gridSendEmail`
   * },
   */
  tokenSendEmail: function () {
    return `${this.pageName}-sendEmail`
  },
  tokenAddDevice: function () {
    return `${this.pageName}-addDevice`
  },
  tokenRemoveDevice: function () {
    return `${this.pageName}-removeDevice`
  },
  tokenAddAllDevice: function () {
    return `${this.pageName}-addAllDevice`
  },
  tokenRemoveAllDevice: function () {
    return `${this.pageName}-removeAllDevice`
  },
  tokenSavePairingDetails: function () {
    return `${this.pageName}-savePairingDetails`
  },
  tokenItemsList: function () {
    return `${this.pageName}-itemsList`
  },
  /*
   * tokenDeleteDeviceList: function () {
   *     return `${this.pageName}-deleteDeviceList`
   * },
   * tokenPermanentPairing: function () {
   *     return `${this.pageName}-permanentPairing`
   * },
   */
  tokenAllSelectedDevice: function () {
    return `${this.pageName}-allSelectedDevice`
  },
  tokenAcceptRequest: function () {
    return `${this.pageName}-acceptRequest`
  },
  tokenDenyRequest: function () {
    return `${this.pageName}-denyRequest`
  },
  tokenDeleteRequest: function () {
    return `${this.pageName}-deleteRequest`
  },
  tokenExpireRequest: function () {
    return `${this.pageName}-expiredRequest`
  },
  tokenEditDeviceName: function () {
    return `${this.pageName}-editDeviceName`
  }
}

export const multiview = {
  multiviewSelectVoipDeviceOpen: 'Multiview3.0-SelectVoipDevice-Open', // 选择voip通话设备弹窗
  multiviewSelectVoipDeviceClose: 'Multiview3.0-SelectVoipDevice-Close',
  multiviewAddReceiver: 'Multiview3.0-Add-Receiver', // 添加设备
  multiviewRemoveReceiver: 'Multiview3.0-Remove-Receiver',
  multiviewBookmarkClose: 'Multiview3.0-Bookmark-Close', // 关闭bookmark选择框
  multiviewBookmarkOpen: 'Multiview3.0-Bookmark-Open', //
  multiviewShowInfoOpen: 'Multiview3.0-ShowInfo-Open', // showInfo按钮开启
  multiviewShowInfoClose: 'Multiview3.0-ShowInfo-Close',
  multiviewSpliteScreen4: 'Multiview3.0-Screen-4', // 当前分屏数量
  multiviewSpliteScreen6: 'Multiview3.0-Screen-6',
  multiviewSpliteScreen9: 'Multiview3.0-Screen-9',
  multiviewSpliteScreen16: 'Multiview3.0-Screen-16',
  multiviewSpliteScreen25: 'Multiview3.0-Screen-25',
  multiviewFullScreenOpen: 'Multiview3.0-FullScreen-Open', // 全屏(隐藏头部)
  multiviewFullScreenClose: 'Multiview3.0-FullScreen-Close',
  multiviewVoipStart: 'Multiview3.0-Voip-Start', // 开始通话
  multiviewVoipReStart: 'Multiview3.0-Voip-ReStart', // 继续通话
  multiviewVoipRefresh: 'Multiview3.0-Voip-ReStart', // 重连 刷新voip
  multiviewAllVoipClose: 'Multiview3.0-AllVoip-Close', // 取消全部voip
  multiviewVideoFullScreenClose: 'Multiview3.0-VideoFullScreen-Close', // video视频关闭全屏
  multiviewVideoFullScreenOpen: 'Multiview3.0-VideoFullScreen-Open',
  multiviewVideoAudioOpen: 'Multiview3.0-VideoAudio-Open', // 视频声音开启
  multiviewVideoAudioClose: 'Multiview3.0-VideoAudio-Close',
  multiviewVideoRefresh: 'Multiview3.0-Video-Refresh', // 刷新视频
  multiviewGoToNewMultiview: 'Multiview3.0-NewMultiview-Goto'
}

export const setting = {
  // 切换tab
  SettingTabExternalSource: 'SettingTab3.0-ExternalSource',
  SettingTabBookmark: 'SettingTab3.0-Bookmark',
  SettingTabAccount: 'SettingTab3.0-Account',
  SettingTabDevice: 'SettingTab3.0-Device',
  SettingTabAccessAPP: 'SettingTab3.0-AccessAPP',
  SettingTabSalesForce: 'SettingTab3.0-SalesForce',
  SettingTabMenuList: 'SettingTab3.0-MenuList',
  SettingTabLicensed: 'SettingTab3.0-Licensed',
  SettingTabFeatureList: 'SettingTab3.0-FeatureList',
  SettingTabMailTemplate: 'SettingTab3.0-MailTemplate',
  SettingTabDeviceChangeLog: 'SettingTab3.0-DeviceChangeLog',
  SettingTabTestInstance: 'SettingTab3.0-TestInstance',
  SettingTabSocialAccount: 'SettingTab3.0-SocialAccount',
  SettingTabVirtualCloudR: 'SettingTab3.0-VirtualCloudR',
  SettingTabGroupManage: 'SettingTab3.0-GroupManage',

  SettingTabAccountAdd: 'SettingTab3.0-Account-Add',
  SettingTabAccountAddSave: 'SettingTab3.0-Account-AddSave',
  SettingTabAccountModify: 'SettingTab3.0-Account-Modify',
  SettingTabAccountModifySave: 'SettingTab3.0-Account-ModifySave',
  SettingTabAccountInactive: 'SettingTab3.0-Account-Inactive',
  SettingTabAccountActive: 'SettingTab3.0-Account-Active',
  SettingTabAccountDelete: 'SettingTab3.0-Account-Delete',
  SettingTabAccountMonitor: 'SettingTab3.0-Account-Monitor',
  SettingTabAccountIncreaseAccount: 'SettingTabAccount-IncreaseAccount',
  SettingTabAccountDegradeRole: 'SettingTab3.0-Account-DegradeRole',
  SettingTabAccountChangeOwner: 'SettingTab3.0-Account-ChangeOwner',
  SettingTabAccountReplaceEmail: 'SettingTab3.0-Account-ReplaceEmail',
  SettingTabAccountBatchReloadAdd: 'SettingTab3.0-Account-BatchReloadAdd',
  SettingTabAccountBatchReloadRemove: 'SettingTab3.0-Account-BatchReloadRemove',
  SettingTabAccountSingleReloadAdd: 'SettingTab3.0-Account-SingleReloadAdd',
  SettingTabAccountSingleReloadRemove: 'SettingTab3.0-Account-SingleReloadRemove',
  SettingTabAccountRoleManagement: 'SettingTab3.0-Account-RoleManagement',
  SettingTabAccountExport: 'SettingTab3.0-Account-Export',
  SettingTabAccountRoleAdd: 'SettingTab3.0-Account-RoleAdd',
  SettingTabAccountRoleModify: 'SettingTab3.0-Account-RoleModify',
  SettingTabAccountRoleDelete: 'SettingTab3.0-Account-RoleDelete',
  SettingTabAccountRoleAccountsAdd: 'SettingTab3.0-Account-RoleAccountsAdd',
  SettingTabAccountRoleAccountsRemove: 'SettingTab3.0-Account-RoleAccountsRemove',
  SettingTabAccountRelationManageSave: 'SettingTab3.0-Account-RelationManageSave',
  SettingTabAccountRelationManagePreviousMethod:
    'SettingTab3.0-Account-RelationManagePreviousMethod',
  SettingTabAccountRelationManageNewMethod:
    'SettingTab3.0-Account-RelationManageNewMethod'
}

export const alert = {
  pageName: 'Alert3.0',
  alertReceiveOpen: function () {
    return `${this.pageName}-inbox-open`
  },
  alertSentOpen: function () {
    return `${this.pageName}-sent-open`
  },
  alertComposeOpen: function () {
    return `${this.pageName}-compose-open`
  },
  alertComposeClose: function () {
    return `${this.pageName}-compose-close`
  },
  alertComposeSend: function () {
    return `${this.pageName}-compose-send`
  },
  alertComposeSearchClick: function () {
    return `${this.pageName}-composeSearch-click`
  },
  alertDeleteClick: function () {
    return `${this.pageName}-delete-click`
  },
  alertInboxMessageClick: function () {
    return `${this.pageName}-inboxMessage-click`
  },
  alertSentMessageClick: function () {
    return `${this.pageName}-sentMessage-click`
  },
  alertComposeFilterClick: function () {
    return `${this.pageName}-composeFilter-click`
  },
  alertComposeBookmarkClick: function () {
    return `${this.pageName}-composeBookmark-click`
  },
  alertBookmarkDeviceListClick: function () {
    return `${this.pageName}-bookmarkDeviceList-click`
  }
}
